export const bridgesTranslations = {
  en: {
    pageTitle: 'Bridges and Locks',
    description: 'Check the status of Bridges and Navigation Locks, updated daily by AIPO.',
    checkBridgesButton: 'Check the status of\nBridges and Locks on AIPo website',
    checkVenetoButton: 'Veneto Region\nInformation on navigable lines'
  },
  it: {
    pageTitle: 'Ponti e Conche',
    description: 'Controlla la situazione di Ponti e Conche di navigazione, aggiornata quotidianamente da AIPO.',
    checkBridgesButton: 'Controlla la situazione di\nPonti e Conche sul sito di AIPo',
    checkVenetoButton: 'Regione Veneto\nInformazioni sulle linee navigabili'
  }
}; 